import { t } from '@lingui/core/macro';
import { useTenantContext } from '@duke-hq/app-provider-web/tenant/TenantContext';
import FilterBarLayout from '@duke-hq/filters/components/FilterBarLayout';
import CourseFilter from './components/provider/CourseFilter';
import ConsultantFilter from './components/provider/ConsultantFilter';
import LocationsFilter from './components/provider/LocationsFilter';
import HealthFilter from './components/HealthFilter';
import SemesterDueDateFilter from './components/SemesterDueDateFilter';
import ProgressFilter from './components/ProgressFilter';
import RecentPaceStatusFilter from './components/RecentPaceStatusFilter';
import ContractTypeFilter from '@duke-hq/filters/components/ContractTypeFilter';

export default function ProviderFilterBar() {
  const tenantCtx = useTenantContext();

  return (
    <FilterBarLayout
      filtersLabel={t`Filters`}
      clearAllLabel={t`Clear All`}
      moreFiltersLabel={t`More filters`}
    >
      <CourseFilter key="course" />
      {tenantCtx?.permissions.includes('canCreateReferralsForTeamMembers') === true ? (
        <ConsultantFilter key="consultant" />
      ) : null}
      <LocationsFilter key="locations" />
      <HealthFilter key="health" />
      <RecentPaceStatusFilter key="recentPaceStatus" />
      <SemesterDueDateFilter key="dueDate" />
      <ProgressFilter key="progress" />
      <ContractTypeFilter key="contractType" />
    </FilterBarLayout>
  );
}
